import { TranslationsToUpdate } from "../models/templates";

export const unwrapSingleParagraph = (html: string | null): string | null => {
  if (typeof html !== "string") return html;

  // Must be exactly one opening <p ...> and one closing </p>
  const openCount = (html.match(/<p>/gi) ?? []).length;
  const closeCount = (html.match(/<\/p>/gi) ?? []).length;
  if (openCount !== 1 || closeCount !== 1) return html;

  // And they must wrap the entire string (whitespace allowed around)
  if (!/^\s*<p>[\s\S]*<\/p>\s*$/i.test(html)) return html;

  // Strip just the outer pair
  return html.replace(/^\s*<p>/i, "").replace(/<\/p>\s*$/i, "");
};

export const stripOuterPFromTranslations = (data: TranslationsToUpdate): TranslationsToUpdate => {
  const out: TranslationsToUpdate = {};
  for (const key in data) {
    const langs = data[key];
    const cleanedLangs: Record<string, string | null> = {};
    for (const lang in langs) {
      cleanedLangs[lang] = unwrapSingleParagraph(langs[lang]);
    }
    out[key] = cleanedLangs;
  }
  return out;
};

export const addOuterPToTranslations = (data: Record<string, string | null>): Record<string, string | null> => {
  if (typeof data !== "object") return data;

  const out: Record<string, string | null> = {};

  for (const lang in data) {
    out[lang] = data[lang];
    if ((out[lang]?.match(/<p\b[^>]*>/gi) ?? []).length == 0) {
      out[lang] = `<p>${data[lang]}</p>`;
    }
  }

  return out;
};
